import { Injectable } from '@angular/core';
import { GenericResponse } from 'projects/Autofacets-Core/src/app/business-entities/generic-response.class';
import { DataService } from 'projects/Autofacets-Core/src/app/services/data.service';
import { Urls } from '../utils/urls';

@Injectable({
  providedIn: 'root'
})

export class SettingDataService {
  constructor(private dataProvider: DataService) {
  }

  getCurrency(): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetCurrency).toPromise();
  }
  getFeatures(): Promise<any> {
    return this.dataProvider.GetAll<GenericResponse<any>>(Urls.GetFeatures).toPromise();
  }
  getGenericFeatures(): Promise<any> {
    return this.dataProvider.GetAll<GenericResponse<any>>(Urls.GetGenericFeatures).toPromise();
  }
  getFeaturesByDealerId(dealerId: string): Promise<any> {
    return this.dataProvider.Get<any>(Urls.GetFeaturesByDealer, dealerId).toPromise();
  }

  GetGenericSettings(): Promise<GenericResponse<any>> {
    return this.dataProvider.Get<any>(Urls.GetGenericSettings).toPromise();
  }
  GetSettings(): Promise<GenericResponse<any>> {
    return this.dataProvider.Get<any>(Urls.GetSettings).toPromise();
  }

}
